/**
 * aida-spa
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const SpaDiscountUnitDTO = {
    percent: 'percent',
    absolute: 'absolute'
} as const;
export type SpaDiscountUnitDTO = typeof SpaDiscountUnitDTO[keyof typeof SpaDiscountUnitDTO];

